import {
  getColumnNumeric,
  getColumnWidth as getFieldDefaultWidth,
} from 'components/Fields/InlineTableFieldInput';
import { getCellForFieldType } from 'components/Layout/BigTableLayout/InlineCells';
import { getBasicColumns } from 'pages/Common/RelatedObjectFields/contact/columns';
import { getObjectUrl } from 'services/FieldService';
import { snakeToCamelCase } from 'services/helpers';
import { FIELD_TYPES } from 'utility/constants';
import {
  SortableHeadCell,
  getBasicColumnMinWidth,
  parseMinWidth,
} from './shared';

export const getColumnsForClient = ({
  columns,
  fields,
  fieldsById,
  onResizeColumnWidth,
  onResizeStop,
  getColumnWidth,
  minWidth,
  resizable,
  model,
  adornments,
}) => {
  const basicColumns = getBasicColumns({ fields, model, adornments });

  return [
    ...columns
      .map((c) => {
        if (basicColumns[snakeToCamelCase(c.name)]) {
          const basicCol = basicColumns[snakeToCamelCase(c.name)];
          const colMinWidth = getBasicColumnMinWidth(basicCol, minWidth);
          return {
            id: c.id,
            label: c.label,
            ...basicCol,
            headCell: (
              <SortableHeadCell
                column={c}
                getColumnWidth={getColumnWidth}
                onResizeColumnWidth={onResizeColumnWidth}
                onResizeStop={onResizeStop}
                narrowestWidth={parseMinWidth(colMinWidth)}
                minWidth={colMinWidth}
                resizable={resizable}
                numeric={basicCol.headCell?.props?.numeric}
              />
            ),
          };
        }

        const field = fieldsById?.[c.id];
        if (!field) {
          return null;
        }

        const fieldAdornments = adornments?.filter(
          (a) => a?.field_type === field?.fieldType
        );
        const fieldMinWidth = getFieldDefaultWidth(field, fieldAdornments) || 200;

        return {
          id: c.id,
          label: c.label,
          headCell: (
            <SortableHeadCell
              column={c}
              getColumnWidth={getColumnWidth}
              onResizeColumnWidth={onResizeColumnWidth}
              onResizeStop={onResizeStop}
              narrowestWidth={fieldMinWidth}
              minWidth={`${fieldMinWidth}px`}
              resizable={resizable}
              numeric={getColumnNumeric(field)}
              hasSorting={field.fieldType !== FIELD_TYPES.Relationship.type}
            />
          ),
          bodyCell: {
            field: { ...field, isReadOnly: true },
            fetchUrl: getObjectUrl('contacts'),
            model,
            minWidth: `${fieldMinWidth}px`,
            Component: getCellForFieldType(field?.fieldType),
            adornments: adornments,
            forceReadOnly: true,
            editable: false,
            disabled: true,
            isCustomObjects: false,
            fieldProps: {},
            dataQaPrefix: 'inline-contact-',
            displayMaskedValue: true,
          },
          meta: {
            editable: false,
          },
        };
      })
      .filter(Boolean),
  ];
};
